import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import packageReducer from './Packages/packagesRedux';
import userReducer from './User/userRedux';
import cabReducer from './cabs/cabRedux';

const rootReducer = combineReducers({
  packages: packageReducer,
  cabs: cabReducer,
  user: userReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
